import React from 'react';
import ActivityDashboardButton from './dashboard-button';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';

class ActicityDashboardButtonContainer extends React.Component {
  constructor () {
    super();

    this.state = {
      scrollPosition: 0
    };

    this.scrollLeft = this.scrollLeft.bind(this);
    this.scrollRight = this.scrollRight.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
  }

  scrollLeft () {
    const scrollContainer = document.getElementById('dashboard-button-scroll-container');
    if (scrollContainer) {
      scrollContainer.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.setState({
        scrollPosition: 0
      });
    }
  }

  scrollRight () {
    const scrollContainer = document.getElementById('dashboard-button-scroll-container');
    if (scrollContainer) {
      const scrollLeft = scrollContainer.scrollWidth - scrollContainer.offsetWidth;
      scrollContainer.scrollTo({
        top: 0,
        left: scrollLeft,
        behavior: 'smooth'
      });
      this.setState({
        scrollPosition: scrollLeft
      });
    }
  }

  handleDrag () {
    const scrollContainer = document.getElementById('dashboard-button-scroll-container');
    if (scrollContainer) {
      this.setState({
        scrollPosition: scrollContainer.scrollLeft
      });
    }
  }

  renderLeftScrollButton () {
    const scrollContainer = document.getElementById('dashboard-button-scroll-container');
    let isMinScrollLeft = true;
    if (scrollContainer) {
      isMinScrollLeft = scrollContainer.scrollLeft === 0;
    }
    if (!isMinScrollLeft) {
      return (<div className='left-scroll-chevron'>
        <img
          onClick={this.scrollLeft}
          src={require('images/icons/chevron-left.svg')}
        />
      </div>);
    }
    return null;
  }

  renderRightScrollButton () {
    const scrollContainer = document.getElementById('dashboard-button-scroll-container');
    let isMaxScrollLeft = false;
    if (scrollContainer) {
      const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.offsetWidth;
      isMaxScrollLeft = scrollContainer.scrollLeft === maxScrollLeft;
    }
    if (!isMaxScrollLeft) {
      return (<div
        onClick={this.scrollRight}
        className='right-scroll-chevron'
      >
        <img src={require('images/icons/chevron-right.svg')} />
      </div>);
    }
  }

  render () {
    let dashboardButtons = [];
    let buttons = [
      {
        icon: require('images/icons/dashboard-register.svg'),
        title: 'BUTTON_REGISTER_ASSIGNMENT',
        buttonStyle: 'secondary',
        link: '/register-assignment',
        openTab: false
      },
      {
        icon: require('images/icons/dashboard-create.svg'),
        title: 'BUTTON_CREATE_INVOICE',
        buttonStyle: 'primary',
        link: '/invoice-tool',
        openTab: false
      },
      {
        icon: require('images/icons/dashboard-proposal.svg'),
        title: 'BUTTON_CREATE_TENDER',
        buttonStyle: 'regular',
        link: proxyCounterpart('CREATE_TENDER_LINK'),
        openTab: true
      },
      {
        icon: require('images/icons/dashboard-agreement.svg'),
        title: 'BUTTON_WRITE_CONTRACT',
        buttonStyle: 'regular',
        link: proxyCounterpart('CREATE_CONTRACT_LINK'),
        openTab: true
      }
    ];

    for (let index = 0; index < buttons.length; index++) {
      dashboardButtons.push(
        <ActivityDashboardButton
          key={index}
          icon={buttons[index].icon}
          title={buttons[index].title}
          buttonStyle={buttons[index].buttonStyle}
          link={buttons[index].link}
          openTab={buttons[index].openTab}
        />
      );
    }

    return (
      <div className='dashboard-button-container'>
        {this.renderLeftScrollButton()}
        <div
          onScroll={this.handleDrag}
          id='dashboard-button-scroll-container'
          className='dashboard-button-scroll-container'
        >
          {dashboardButtons}
        </div>
        {this.renderRightScrollButton()}
      </div>
    );
  }
}

export default ActicityDashboardButtonContainer;



/** WEBPACK FOOTER **
 ** ./src/components/dashboard-buttons/dashboard-button-container.js
 **/